import React, { useContext } from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext from '../../contexts/language';
import AuthContext from '../../contexts/auth';

export default function Imprensa() {

    const { signed } = useContext(AuthContext);
    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    return (
        <div className="page">
            <Header />
            <div className="content">
                <div className="full mt-30 mb-40 text-center form">
                    <h3 className="title_b color_5 mb-20">
                        {language.menu_imprensa_press}
                    </h3>
                    <div className="row w-100">
                        <div className="col-md-12 m-auto text text-center">
                            <h4 className="mb-0"><strong>{lang==='pt' ? 'EM BREVE' : 'COMING SOON'}</strong></h4>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
